/* tslint:disable */
export enum AttendanceExportType {
  Export1 = 1,
  Export2 = 2
}
